module.exports = __webpack_public_path__ + "media/images/icons/Meat-6610e2f8fcbc446a79e9858ad5eedd7a.svg";